import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { reduxForm, Field } from 'redux-form'
import QS from 'qs'
import { PASSWORD_LENGTH_MAX } from '@adalo/constants'

import Button from '../Shared/Button'
import WrappedInput from '../Shared/Forms/WrappedInput'
import AuthPageLogo from './Logo'

const FORM_NAME = 'loginForm'

class LoginForm extends Component {
  render() {
    const { handleSubmit, error, submitting, redirect } = this.props
    const redirectQuery = QS.stringify({ redirect }, { addQueryPrefix: true })

    return (
      <form onSubmit={handleSubmit} className="auth-form">
        <AuthPageLogo />
        <h1>Sign In</h1>
        <Field
          autoFocus
          name="email"
          placeholder="me@example.com"
          type="email"
          label="Email Address"
          maxLength={255}
          autoComplete="email"
          component={WrappedInput}
        />
        <Field
          name="password"
          placeholder="••••••••"
          type="password"
          label="Password"
          maxLength={PASSWORD_LENGTH_MAX}
          autoComplete="current-password"
          component={WrappedInput}
        />
        <div className="auth-form-submission-row">
          <Button large yellow loading={submitting}>
            Sign In
          </Button>
        </div>
        {error && <div className="auth-form-error">{error}</div>}
        <div className="auth-form-link">
          <Link to="/forgot-password" className="link-button">
            Forgot Password?
          </Link>
        </div>
        <div className="auth-form-link">
          {'No account? '}
          <Link to={`/signup${redirectQuery}`} className="link-button">
            Signup
          </Link>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: FORM_NAME,
})(LoginForm)
